const ID = {
  id: 'id',
  label: 'list.id',
  type: 'text'
}
const KEY = {
  id: 'masked_key',
  label: 'list.key',
  type: 'text'
}
const NAME = {
  id: 'name',
  label: 'list.name',
  type: 'text'
}
const CREATED_AT = {
  id: 'created_at',
  label: 'list.createdAt',
  type: 'date',
  format: 'date'
}
const ACCESS = {
  id: 'scope',
  label: 'list.access',
  type: 'label-tooltip'
}
const ACTION_DELETE = {
  type: 'action_delete'
}

const FIELDS = [KEY, NAME, CREATED_AT, ACCESS]

const getFields = (isEmployee, showButtonDelete) => {
  let _fields = FIELDS
  if (isEmployee) _fields = [ID, ..._fields]
  if (showButtonDelete) _fields = [..._fields, ACTION_DELETE]
  return _fields
}

export { getFields }
